
import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableRow  } from '@mui/material';
import Layout from '../Layout/Layout';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function AllGateways() {
    const [gateways, setGateways] = useState([]);
    const axiosInstance = useAxiosPrivate();

    useEffect(() => {
        const fetchGateways = async () => {
            try {
                const response = await axiosInstance.get('/fwd/assg/listall', {
                    withCredentials: true,
                });
                setGateways(response.data);
            } catch (error) {
                console.error('Error fetching gateways:', error);
            }
        };

        fetchGateways();
    }, []);



    return (
        <Layout>
                <Table>
                    <TableBody>
                        {gateways.map((gateway) => (
                            <TableRow>
                                <pre>{JSON.stringify(gateway, null, 2)}</pre>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
        </Layout>
    );
}


export default AllGateways;
